import { Injectable } from '@angular/core';
// @ts-ignore
@Injectable({
  providedIn: 'root'
})
export class SclDatatableResponsiveService {

  constructor() { }

  responsiveInit(fieldName) {
    this.checkColHidden(fieldName);
    // this.expandHandler(fieldName);
  }

  changeMediaScreen(fieldName) {
    const doc = (document.getElementById(fieldName).childNodes[1] as any);
    doc.childNodes.forEach((val, i) => {
      if (doc.childNodes[i].className === 'child') {
        const el = doc.childNodes[i];
        el.parentNode.removeChild(el);
        //   doc.childNodes[i].remove();
      }
    });

    doc.childNodes.forEach((val, i) => {
      if (doc.childNodes[i].classList.contains('parent')) {
        doc.childNodes[i].classList.remove('parent');
      }
    });
  }

  columnWidthHandler(device) {
    // if(scope.fieldName){
    //   const componentElement = document.getElementById(scope.fieldName);
    //   let maxWidth = this.getMaxWidth(device);
    //   let tWidth = window.innerWidth - 42;
    //   if (componentElement && componentElement.rows && componentElement.rows[0] && componentElement.rows[0]) {
    //     let tds = componentElement.rows[0].children;
    //     let maxColWidth = 0;
    //     // for(let i in tds){
    //     for(let i=0; i<tds.length; i++){
    //       let td = tds[i];
    //       if(window.getComputedStyle(td,null).getPropertyValue('display') != "none"){
    //         let regex = new RegExp("dt-"+device+"-(\\d)", "g");
    //         let wr = parseInt(regex.exec(td.className)[1]);
    //         let cw = (wr/maxWidth)*100;
    //
    //         // td.style.width = cw+"%";
    //       }
    //     }
    //   }
    // }else{
    //   logger.error("fieldName is not set.");
    // }
  }

  getMaxWidth(device) {
    // let maxColWidth = 0;
    // if(scope.fieldName){
    //   const componentElement = document.getElementById(scope.fieldName);
    //
    //   if (componentElement && componentElement.rows && componentElement.rows[1] && componentElement.rows[1]) {
    //     let tds = componentElement.rows[1].children;
    //     // for(let i in tds){
    //     for(let i=0; i<tds.length; i++){
    //       let td = tds[i];
    //       if(window.getComputedStyle(td,null).getPropertyValue('display') != "none"){
    //         let regex = new RegExp("dt-"+device+"-(\\d)", "g");
    //         maxColWidth += parseInt(regex.exec(td.className)[1]);
    //       }
    //     }
    //   }
    // }else{
    //   logger.error("fieldName is not set.");
    // }
    // return maxColWidth;
  }

  calculateWidth(fieldName) {

    if (fieldName) {
      const componentElement = (document.getElementById(fieldName) as any);
      if (componentElement && componentElement.rows && componentElement.rows[1] && componentElement.rows[1]) {
        const ths = componentElement.rows[0].children;
        const tblWidth = window.innerWidth - 168;
        let maxWidth = 0;
        for (let i = 0; i < ths.length; i++) {
          const th = ths[i];
          if (this.isVisible(th)) {
            let width = 1;
            const colW = th.className.match(/colWidth-([0-9])/);
            if ( colW ) {
              width = colW.pop();
            }
            maxWidth += (width * 1);
          }
        }

        for (let i = 0; i < ths.length; i++) {
          const th = ths[i];

          if (this.isVisible(th)) {
            let width = 1;
            const colW = th.className.match(/colWidth-([0-9])/);
            if ( colW ) {
              width = colW.pop();
            }
            const colWidth = (width / maxWidth) * tblWidth;

            /*th.style.width = ( parseInt(window.getComputedStyle(th, null)
              .getPropertyValue('width')) + 1) + 'px';*/

            th.style.width = colWidth + 'px';
          }
        }
      }
    } else {
      console.error('fieldName is not set.');
    }
  }

  isVisible(e) {
    return !!( e.offsetWidth || e.offsetHeight || e.getClientRects().length );
  }

  expandHandler(fieldName) {

    if (fieldName) {
      const componentElement = document.getElementById(fieldName);
      if (componentElement) {
        const tds = componentElement.querySelectorAll('.dataTable.hasHidden tbody td:first-child .handler');
        for (let i = 0; i < tds.length; i++) {
          const td = (tds[i] as HTMLElement);

          td.onclick = (e) => {
            e.stopPropagation();
            if (document.getElementById(fieldName).classList.contains('hasHidden')) {

              const headings = document.querySelector('#' + fieldName + ' thead tr').children;

              const newElement = document.createElement('tr');
              newElement.className = 'child';
              const newElementTd = document.createElement('td');

              let tr = (td.parentNode.parentNode as HTMLElement);
              let tbl = tr.parentNode;
              let tds_child = tr.children;
              let ul = document.createElement('ul');
              ul.className = 'dtr-details';

              if (!tr.classList.contains('scl-dt-parent')) {

                tr.classList.add('scl-dt-parent');
                let colSize = 0;

                // for(let k in tds_child){

                for (let k = 0; k < tds_child.length; k++) {
                  let td = tds_child[k];
                  if(window.getComputedStyle(td, null).getPropertyValue('display') === 'none') {
                    let li = document.createElement('li');

                    let spanTitle = document.createElement('span');
                    let spanData = document.createElement('span');

                    spanTitle.classList.add('dtr-title');
                    spanTitle.innerHTML = headings[k].innerHTML;
                    li.appendChild(spanTitle);

                    spanData.classList.add('dtr-data');
                    spanData.innerHTML = td.innerHTML;
                    li.appendChild(spanData);
                    ul.appendChild(li);

                  } else {
                    colSize++;
                  }
                  // j++;
                }

                newElementTd.colSpan = colSize;
                newElementTd.appendChild(ul);
                newElement.appendChild(newElementTd);
                tbl.insertBefore(newElement, tr.nextSibling );
              } else {
                tr.classList.remove('scl-dt-parent');
                let el = tr.nextSibling;
                el.parentNode.removeChild(el);

              }
            }
            e.preventDefault();
          };

        }
      }
    } else {
      console.log('fieldName is not set.');
    }
  }

  checkColHidden(fieldName) {

    if (fieldName) {
      const componentElement = (document.getElementById(fieldName) as any);

      if (componentElement && componentElement.rows && componentElement.rows[0] && componentElement.rows[0]) {
        let tds = componentElement.rows[0].children;
        let foundHidden = false;
        // for(let i in tds){
        for (let i = 0; i < tds.length; i++) {
          let td = tds[i];
          if(window.getComputedStyle(td, null).getPropertyValue('display') === 'none'){
            foundHidden = true;
            document.getElementById(fieldName).classList.add('hasHidden');
            break;
          }

        }

        if (foundHidden) {
          document.getElementById(fieldName).classList.add('hasHidden');
        } else {
          document.getElementById(fieldName).classList.remove('hasHidden');
        }

        // looking for last-child th
        let isLastElm = false;
        for (let i = tds.length - 1; i >= 0; i--) {
          if (window.getComputedStyle(tds[i], null).getPropertyValue('display') === 'none') {
            tds[i].classList.remove('last-child-th');
          } else {
            if (!isLastElm) {
              tds[i].classList.add('last-child-th');
              isLastElm = true;
            } else {
              tds[i].classList.remove('last-child-th');
            }
          }
        }
      }

    } else {
      console.error('fieldName is not set.');
    }
  }
}
